import collect from 'collect.js';
import { pathToRegexp } from 'path-to-regexp';
import router from '../router';
import store from '@/store';

export function canAccess(url, permission = true) {
  if (!permission) {
    return true;
  }
  const user = store.getters['user/user'];
  const roles = collect(user.roles);
  if (user.is_god) {
    return true;
  }

  if (roles.where('name', 'Owner').isNotEmpty()) {
    return true;
  }

  const orgRoles = window.GORILLA_ROLES[window.gd_settings.organisation_id];
  const checkRoles = roles.map((role) => {
    return collect(orgRoles[role.id].paths).filter((orgRole) => {
      const re = pathToRegexp(orgRole);
      const urls = collect().wrap(url).map(item => router.resolve(item).href);
      return urls.filter((item) => {
        return re.exec(item) !== null;
      })
        .isNotEmpty();
    })
      .collapse()
      .all();
  })
    .collapse();

  return checkRoles.isNotEmpty();
}

export default {
  methods: {
    canAccess(url, permission = true) {
      return canAccess(url, permission);
    },
  },
};

